import React from 'react'
import Hero from './Hero'
import About from './About'
import Works from './Work'
import Skills from './Skills'
import Project from './Project'
import Contact from './Contact'
import Footer from './Footer'

const Homepage = () => {
  return (
    <div>
     
   
 <Hero/>
  <About/> 
  <Works/>
  <Skills/> 
   <Project/>
   <Contact/>
   <Footer/> 
    </div>
  )
}

export default Homepage